<template>
  <div :id="parte_key" class="tab-detalle has-text-left">
    <h3 class="has-text-weight-bold is-red is-uppercase">
      {{ this.$i18n.t('general.'+parte_key) }}

      <b-field v-if="!parte.obligatorio">
        <b-switch v-model="activar"


                  type="is-primary">
          {{ activar ? this.$i18n.t('general.Yes') : this.$i18n.t('general.No')}}
        </b-switch>
      </b-field>
    </h3>
      <div v-if="parte.es_array">
        <b-field v-for="opcion in opcionesvalidas" :key="'op_'+opcion.codigo">

          <b-radio  v-model="selected_opcion"
                    :native-value="opcion.codigo"
                    type="is-primary"
                    :disabled="!activar || incompatible.includes(opcion.codigo)"


          >

            {{ opcion.nombre[lang.replace('_','-').toLowerCase()] }}

          </b-radio>
        </b-field>
        <hr>
      </div>
      <div>


      </div>




  </div>
</template>

<script>
export default {
  name: "selOpcionesPartes",
  props: {'parte': Object,'parte_key' : String,'lang' : String},
  data (){
    return {
      selected_opcion: null,
      selected_opcion2: null,
      activar: true,
      emitir: false,
      incompatible: [],


    }
  },
  computed: {
      estado: function () {
        return this.activar
      },
      seleccionado: function (){
        let op = this.parte.opciones.filter(o=>o.disabled==false)
        if (typeof op !=='undefined'){
          let d = op.find(v => v.default === true )
          if (typeof d !== 'undefined'){
            return d.codigo
          }else{
            return null
          }
        }else{
          return null
        }



        //return this.parte.seleccionado
      },
      variaciones: function () {
        return this.$store.getters.getVariaciones;
      },
      opcionesvalidas : function (){

        let opciones = this.parte.opciones

        opciones.forEach(o => {

            if (this.incompatible.includes(o.codigo)){
              o.disabled = true
            }else{
              o.disabled = false
            }


        })
        //console.log('Opciones Validas !')

        return opciones
        //return opciones.filter(v => !this.incompatible.includes(v.codigo))
      }


  },
  mounted: function () {

    this.emitir=false;
    let d = this.parte.opciones.find(v => v.default === true)
    if(typeof d !=='undefined'){
      let objt = {
        'parte' : this.parte_key,
        'val' : d.codigo
      }
      this.$store.commit('setParteSeleccionada',objt)
      this.selected_opcion = d.codigo
      this.setIncompatibilidades()
    }



  },

  methods: {
    //:incluir="partes[parte].obligatorio"
    //:selected_option="partes[parte].opciones.filter(v => { return v.default == true})[0].codigo"
    selOpcion(){

      this.$store.commit('setIsConfigFromHash',false)


    },
    selColor(color) {
      this.selected_color = color
    },
    setIncompatibilidades(){
      let modelo = this.$store.getters.getModeloActivo;
      let opcionesincompatibles = []
      if (typeof modelo !== 'undefined') {
        //console.log(this.parte_key)
        let partes = this.$store.getters.getPuenteLavadoActivo.modelos.find(m => m.codigo === modelo).partes
        let parteskeys = this.$store.getters.getPartesKeys
        let otraspartes = {}
        //console.log(partes)
        //console.log(parteskeys)
        if (typeof parteskeys !== 'undefined' && parteskeys.length>0){
          parteskeys.forEach(e => {
            if (e !==this.parte_key) {
              if (typeof partes[e] !== 'undefined'){
                otraspartes[e]=partes[e].opciones
                let mop = partes[e].opciones.find(o => o.codigo === this.$store.getters.getPartesSeleccionadas[e])
                if (typeof mop !=='undefined'){
                  if (typeof mop.incompatible !=='undefined'){
                    if (this.parte_key in mop.incompatible){
                      opcionesincompatibles = mop.incompatible[this.parte_key]

                    }
                  }
                }
              }
            }

          })
        }


        //console.log(otraspartes)
      }
      //console.log(opcionesincompatibles)
      this.incompatible = opcionesincompatibles
      if (opcionesincompatibles.includes(this.selected_opcion)){

        let t = this.parte.opciones.find(o=>o.disabled==false)
        if (typeof t !== 'undefined' && 'codigo' in t){
          this.selected_opcion = this.parte.opciones.find(o=>o.disabled==false).codigo
        }else{
          this.selected_opcion = null
        }
        //console.log('la opcion seleccionada '+this.selected_opcion+' es incompatible !!!')
        ///console.log(this.parte.opciones.find(o=>o.disabled==false).codigo)


      }
    }
  },
  watch: {
    estado : function (newEstado) {
      if (this.emitir===true){
        console.log('Emite --> estado 1 ???')
        this.$store.commit('setSolicitar',true)
        this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'mostrar',valor: newEstado, opcion: this.selected_opcion})
      }

      if (newEstado){
        let op =this.parte.opciones.map(op => op.codigo).filter(f => f !== this.selected_opcion)
        if(this.emitir===true){
          console.log('Emite --> estado 2')
          let objt = {
            'parte' : this.parte_key,
            'val' : this.selected_opcion
          }
          this.$store.commit('setParteSeleccionada',objt)
          this.$store.commit('setSolicitar',true)
          this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'opcion',valor: this.selected_opcion, 'opciones': op})
        }

      }
    },
    selected_opcion: function (newSel){
      //console.log('SELOPCIONESPARTES: Cambios la opcion:' + newSel)
      let op =this.parte.opciones.map(op => op.codigo).filter(f => f !== newSel)
      if (this.activar){
        //console.log(op)
        if (this.emitir===true){
          console.log('Emite --> selected_opcion:' + newSel)
          let objt = {
            'parte' : this.parte_key,
            'val' : newSel
          }
          this.$store.commit('setParteSeleccionada',objt)
          this.$store.commit('setSolicitar',true)
          this.setIncompatibilidades()

          this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'opcion',valor: newSel, 'opciones': op})
        }

      }

    },
    seleccionado : function () {
      let d = this.parte.opciones.find(v => v.default === true)

      if (typeof d !== 'undefined'){

        this.selected_opcion = d.codigo
      }

    },
    variaciones: function () {
      this.emitir=false
      if (typeof this.variaciones !=='undefined'){
        this.setIncompatibilidades()
        let v = this.variaciones.find(v => v.parte == this.parte_key)
        if (typeof v == 'object' && 'valor' in v){
          if (v.valor == false){

            this.activar = false;

          }else{
            if (this.incompatible.includes(v.valor)){
              //console.log('Entramos aqui !!! ' + this.parte_key)
              //console.log(this.variaciones)
              this.$store.commit('setVariaciones', this.variaciones.filter(v => v.parte !== this.parte_key))
              //let p= this.variaciones.splice(this.variaciones.indexOf(v => v.parte == this.parte_key),1)
              //console.log(p)
              this.emitir = true
              this.selected_opcion = null
              //let op =this.parte.opciones.map(op => op.codigo).filter(f => f !== this.selected_opcion)
              //this.$emit('registrar-cambio',{'parte': this.parte_key, cambio: 'opcion',valor: this.selected_opcion, 'opciones': op})
            }else{
              this.selected_opcion = v.valor
            }

          }


        }
      }
      this.emitir=true




    }
  }
}
</script>

<style scoped>

</style>
